// cadastro.component.ts
import { Component } from '@angular/core';

@Component({
  selector: 'empresa-root',
  templateUrl: './empresa.component.html',
  styleUrls: ['./empresa.component.css']
})
export class EmpresaComponent {
  title = 'empresa-sest-senat';
}


// WEBPACK FOOTER //
// ./src/app/components/_public-layout/pages/empresa/empresa.component.ts